<template>
  <div v-on:keyup.enter="onEnter">
    <b-sidebar id="sidebar-Atendimento" ref="refSidebar" :title="title" right shadow backdrop-variant="white" variant="white" backdrop>
      <template #footer>
        <div style="gap: .5rem; justify-content: space-between"
          class="d-flex bg-dark text-light align-items-center px-3 py-2">
          <!-- Botão ocupa toda a largura -->
          <button type="button" class="btn rounded-4 btn-third w-100" @click="$emit('submit')">
            Próximo
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
      </template>
      <div>
        <slot></slot>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: 'NxSearch',
  props: {
    title: {
      type: String,
      required: false,
      default: 'Pesquisar'
    }
  },
  methods: {
    onEnter () {
      this.$emit('submit')
    }
  }
}
</script>

<style lang="scss">
.b-sidebar#sidebar-Atendimento {
  top: 3.5rem;
  height: calc(100vh - 3.5rem);
  width: 500px;
}

</style>



// WEBPACK FOOTER //
// src/containers/layout/sidebars/SidebarAtendimento.vue